import { render, staticRenderFns } from "./SimpleSelect.vue?vue&type=template&id=87775222&scoped=true&"
import script from "./SimpleSelect.vue?vue&type=script&lang=js&"
export * from "./SimpleSelect.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSelect.vue?vue&type=style&index=0&id=87775222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87775222",
  null
  
)

export default component.exports